<header class="app-header navbar">
  <button class="navbar-toggler d-lg-none button" type="button" appMobileSidebarToggler>&#9776;</button>
  <a class="navbar-brand button" [routerLink]="['/dashboard']"></a>
  <ul class="nav navbar-nav d-md-down-none">
    <li class="nav-item px-3">
      <a class="nav-link button" [routerLink]="['/dashboard']">Início</a>
    </li>
    <li class="nav-item px-3">
      <a class="nav-link button" [routerLink]="['/estudo']">Estudo</a>
    </li>
    <li class="nav-item px-3" *ngIf="user.tipo === 'G'">
      <a class="nav-link button" [routerLink]="['/gestao']">Gestão</a>
    </li>
    <li class="nav-item px-3">
      <a class="nav-link button" [routerLink]="['/relatorios']">Relatórios</a>
    </li>
    <li class="nav-item px-3">
      <a class="nav-link button" [routerLink]="['/servicos']">Serviços</a>
    </li>
    <li class="nav-item px-3">
      <a class="nav-link button" [routerLink]="['/suporte']">Suporte</a>
    </li>
  </ul> 
  
  <ul class="nav navbar-nav ml-auto">
  <div class="navbar-nav">
      <small style="text-align: left">
        Usuário: <b>{{ user.id }}</b> <br>
        Loja: <b>{{ user.nome_assoc }}</b><br>
        CNPJ: <b>{{ user.cnpj }}</b><br>
      </small>
  </div>
    <li class="nav-item dropdown" dropdown>
      <a href="" class="nav-link dropdown-toggle" dropdownToggle (click)="false">
        <i class="fa fa-user"></i>
        <span class="d-md-down-none"></span>
      </a>
      <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">

        <div class="dropdown-header text-center"><strong>Informações</strong></div>
        <div class="dropdown-item">
          <i class="fa fa-user"></i> {{ user.id }} - {{ user.nome }}
        </div>
        <div class="dropdown-item">
          <i class="fa fa-users"></i> {{ (user.tipo === 'G') ? 'Gestor' : 'Associado - ' + user.associado }}
        </div>
        <div class="dropdown-header text-center"><strong>Ações</strong></div>

        <button class="dropdown-item button" (click)="openModal('usuario')">
          <i class="fa fa-user"></i> Alterar Dados
        </button>
        <a class="dropdown-item button" (click)="onLogout();"><i class="fa fa-lock"></i> Logout</a>
      </div>
    </li>
    <li class="nav-item d-md-down-none">
      <!--<a class="nav-link navbar-toggler button" href="#" appAsideMenuToggler>&#9776;</a>-->
    </li>
  </ul>
</header>

<div class="app-body">
  <div class="sidebar">
    <nav class="sidebar-nav">
      <ul class="nav">
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/dashboard']"><i class="fa fa-bar-chart"></i>
            Painel </a>
        </li>
        <li class="divider"></li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/estudo']"><i class="fa fa-tasks"></i>
            Estudo</a>
        </li>
        <li class="nav-item nav-dropdown" routerLinkActive="open" appNavDropdown *ngIf="user.tipo === 'G'">
          <a class="nav-link" [routerLink]="['/gestao']" href="#" routerLinkActive="active"><i
            class="fa fa-plus-square"></i> Gestão </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/relatorios']" href="#" routerLinkActive="active"><i
            class="fa fa-pie-chart"></i> Relatórios</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/suporte']" href="#" routerLinkActive="active"><i
            class="fa fa-comments-o"></i> Suporte</a>
        </li>
      </ul>
    </nav>
  </div>

  <!-- Main content -->
  <main class="main">

    <!-- Breadcrumb -->
    <ol class="breadcrumb">
      <app-breadcrumbs></app-breadcrumbs>
      <!-- Breadcrumb Menu-->
      <!--<li class="breadcrumb-menu d-md-down-none">
        <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
          <button class="btn btn-secondary button" [routerLink]="['/dashboard']">
            <i class="fa fa-area-chart"></i> &nbsp;Painel
          </button>
          <button class="btn btn-secondary button">
            <i class="fa fa-cog"></i> &nbsp;Configurações
          </button>
        </div>
      </li>-->
    </ol>

    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div><!-- /.conainer-fluid -->
  </main>

  <aside class="aside-menu">
  <tabset>
    <tab>
      <ng-template tabHeading><i class="fa fa-bug"></i></ng-template>
      <div class="m-0 py-2 text-center text-uppercase">
        <small><b>Log Sistema</b></small>
      </div>
      <div class="p-3">
        <div class="message">
          <div class="py-3 pb-5 mr-3 float-left">
          </div>
          <div>
            <small class="text-muted">Log</small>
            <small class="text-muted float-right mt-1">1:52 PM</small>
          </div>
          <div class="text-truncate font-weight-bold">Lorem ipsum dolor sit amet</div>
          <small class="text-muted">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
            incididunt...
          </small>
        </div>
        <hr>
        <div class="m-0 py-2 text-center text-uppercase">
          <small><b>Log Erros</b></small>
        </div>
        <div class="message">
          <div class="py-3 pb-5 mr-3 float-left"></div>
          <div>
            <small class="text-muted">Log</small>
            <small class="text-muted float-right mt-1">1:52 PM</small>
          </div>
          <div class="text-truncate font-weight-bold">Lorem ipsum dolor sit amet</div>
          <small class="text-muted">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
            incididunt...
          </small>
        </div>
      </div>
    </tab>
  </tabset>
</aside>
</div>

<footer class="app-footer">
  <span class="float-right">&copy; {{ data.getFullYear() }} SPA - Farmácias Associadas.</span>
</footer>
